/* tslint:disable */
import { ValueListItem } from "./ValueListItem"

export class ValueList {
		Id: number;
		Name: string;

		ValueListItems: ValueListItem[];
}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/ValueList.ts